var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack354({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4,9l.55,0a1.57,1.57,0,0,0,.2.69A1.12,1.12,0,0,0,5.2,10a1.41,1.41,0,0,0,.65.15,1.17,1.17,0,0,0,.81-.25A.85.85,0,0,0,7,9.28a.73.73,0,0,0-.11-.42.8.8,0,0,0-.31-.29,6.67,6.67,0,0,0-.91-.32,3.11,3.11,0,0,1-.89-.37,1.33,1.33,0,0,1-.41-.47,1.51,1.51,0,0,1-.14-.65A1.44,1.44,0,0,1,4.6,5.69a1.57,1.57,0,0,1,1.13-.41,1.79,1.79,0,0,1,.86.19A1.34,1.34,0,0,1,7.16,6a1.79,1.79,0,0,1,.22.85l-.56,0a1.14,1.14,0,0,0-.31-.77,1.06,1.06,0,0,0-.76-.26A1.1,1.1,0,0,0,5,6.13a.68.68,0,0,0-.26.57.63.63,0,0,0,.19.5,2.14,2.14,0,0,0,.86.37,5.69,5.69,0,0,1,.91.31,1.54,1.54,0,0,1,.61.54,1.46,1.46,0,0,1,.2.8,1.69,1.69,0,0,1-.21.84,1.56,1.56,0,0,1-.59.58,1.93,1.93,0,0,1-.9.19,1.75,1.75,0,0,1-1.3-.49A1.86,1.86,0,0,1,4,9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.43,8.86,12,9a2.54,2.54,0,0,1-.68,1.35,1.68,1.68,0,0,1-1.18.44,1.88,1.88,0,0,1-1.05-.29,2.16,2.16,0,0,1-.71-1A4.1,4.1,0,0,1,8.12,8a3.72,3.72,0,0,1,.28-1.5,2.21,2.21,0,0,1,.75-.93,1.88,1.88,0,0,1,1.06-.31,1.62,1.62,0,0,1,1.09.39,2.15,2.15,0,0,1,.64,1.17L11.37,7q-.28-1.11-1.17-1.11a1.32,1.32,0,0,0-.77.22,1.6,1.6,0,0,0-.51.7A3.23,3.23,0,0,0,8.73,8a2.86,2.86,0,0,0,.38,1.65,1.22,1.22,0,0,0,1,.56A1.17,1.17,0,0,0,11,9.89,1.86,1.86,0,0,0,11.43,8.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack354);
export default __webpack_public_path__ + "static/media/Symbol_pack_354.4c97d3e4201cea6d712313ba6dbfdff4.svg";
export { ForwardRef as ReactComponent };